// utils/roles.ts
export const ROLES = {
  root: 'root',
  org_oper: 'оператор организации',
  plant_oper: 'оператор объекта',
  station_owner: 'владелец станции',
} as const;

export type RoleType = typeof ROLES[keyof typeof ROLES];
